export const isTokenExpired = (expires: any): boolean => {
    const expiresTime = Number(expires);
    const currentTime = Math.floor(Date.now() / 1000);

    return expiresTime < currentTime;
};